// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { polyfill } from 'es6-promise'
polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import { store } from './store/store'
import 'vuetify/dist/vuetify.min.css'
import IdleVue from 'idle-vue'
import JsonExcel from 'vue-json-excel'

import VueKonva from 'vue-konva'

Vue.component('downloadExcel', JsonExcel)

Vue.use(VueKonva)

Vue.use(Vuetify, { theme: {
    primary: '#bd0000',
    secondary: '#004034',
    accent: '#bd0000',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#e75869',
    customPurple: '#bd0000',
    primary_blue:'#bd0000',
    nav_background_color: '#bd0000'
}})


const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1200000
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  onIdle() {
   // var url = window.location.href;
    // var to = url.lastIndexOf('/') +1;
    // window.location=url.substring(0,to);
    location.reload()
  },
  onActive() {
    this.messageStr = 'Sesión Activa'
  }
},)



// WEBPACK FOOTER //
// ./src/main.js